export enum PaymentSteps {
  FILL_LICENSE_PLATE = 'FILL_LICENSE_PLATE',
  FILL_LICENSE_PLATE_ERROR = 'FILL_LICENSE_PLATE_ERROR',
  INVOICE = 'INVOICE',
  INVOICE_ERROR = 'INVOICE_ERROR',
  FINISH = 'FINISH',
  FINISH_ERROR = 'FINISH_ERROR',
}
